module.exports = [
  {
    "Race": "Majority Non-Black",
    "Age": 55,
    "Count": 0
  },
  {
    "Race": "Majority Non-Black",
    "Age": 56,
    "Count": 0
  },
  {
    "Race": "Majority Non-Black",
    "Age": 57,
    "Count": 0
  },
  {
    "Race": "Majority Non-Black",
    "Age": 58,
    "Count": 0
  },
  {
    "Race": "Majority Non-Black",
    "Age": 59,
    "Count": 0
  },
  {
    "Race": "Majority Non-Black",
    "Age": 60,
    "Count": 0
  },
  {
    "Race": "Majority Non-Black",
    "Age": 61,
    "Count": 0
  },
  {
    "Race": "Majority Non-Black",
    "Age": 62,
    "Count": 0
  },
  {
    "Race": "Majority Non-Black",
    "Age": 63,
    "Count": 0
  },
  {
    "Race": "Majority Non-Black",
    "Age": 64,
    "Count": 0
  },
  {
    "Race": "Majority Non-Black",
    "Age": 65,
    "Count": 0
  },
  {
    "Race": "Majority Non-Black",
    "Age": 66,
    "Count": 0
  },
  {
    "Race": "Majority Non-Black",
    "Age": 67,
    "Count": 2
  },
  {
    "Race": "Majority Non-Black",
    "Age": 68,
    "Count": 0
  },
  {
    "Race": "Majority Non-Black",
    "Age": 69,
    "Count": 5
  },
  {
    "Race": "Majority Non-Black",
    "Age": 70,
    "Count": 5
  },
  {
    "Race": "Majority Non-Black",
    "Age": 71,
    "Count": 6
  },
  {
    "Race": "Majority Non-Black",
    "Age": 72,
    "Count": 14
  },
  {
    "Race": "Majority Non-Black",
    "Age": 73,
    "Count": 12
  },
  {
    "Race": "Majority Non-Black",
    "Age": 74,
    "Count": 19
  },
  {
    "Race": "Majority Non-Black",
    "Age": 75,
    "Count": 16
  },
  {
    "Race": "Majority Non-Black",
    "Age": 76,
    "Count": 12
  },
  {
    "Race": "Majority Non-Black",
    "Age": 77,
    "Count": 17
  },
  {
    "Race": "Majority Non-Black",
    "Age": 78,
    "Count": 12
  },
  {
    "Race": "Majority Non-Black",
    "Age": 79,
    "Count": 17
  },
  {
    "Race": "Majority Non-Black",
    "Age": 80,
    "Count": 16
  },
  {
    "Race": "Majority Non-Black",
    "Age": 81,
    "Count": 9
  },
  {
    "Race": "Majority Non-Black",
    "Age": 82,
    "Count": 4
  },
  {
    "Race": "Majority Non-Black",
    "Age": 83,
    "Count": 6
  },
  {
    "Race": "Majority Non-Black",
    "Age": 84,
    "Count": 2
  },
  {
    "Race": "Majority Non-Black",
    "Age": 85,
    "Count": 1
  },
  {
    "Race": "Majority Non-Black",
    "Age": 86,
    "Count": 0
  },
  {
    "Race": "Majority Non-Black",
    "Age": 87,
    "Count": 0
  },
  {
    "Race": "Majority Non-Black",
    "Age": 88,
    "Count": 1
  },
  {
    "Race": "Majority Non-Black",
    "Age": 89,
    "Count": 0
  },
  {
    "Race": "Majority Non-Black",
    "Age": 90,
    "Count": 0
  },
  {
    "Race": "Majority Non-Black",
    "Age": 91,
    "Count": 0
  },
  {
    "Race": "Majority Non-Black",
    "Age": 92,
    "Count": 0
  },
  {
    "Race": "Majority Non-Black",
    "Age": 93,
    "Count": 0
  },
  {
    "Race": "Majority Non-Black",
    "Age": 94,
    "Count": 0
  },
  {
    "Race": "Majority Black",
    "Age": 55,
    "Count": 0
  },
  {
    "Race": "Majority Black",
    "Age": 56,
    "Count": 0
  },
  {
    "Race": "Majority Black",
    "Age": 57,
    "Count": 0
  },
  {
    "Race": "Majority Black",
    "Age": 58,
    "Count": 0
  },
  {
    "Race": "Majority Black",
    "Age": 59,
    "Count": 0
  },
  {
    "Race": "Majority Black",
    "Age": 60,
    "Count": 0
  },
  {
    "Race": "Majority Black",
    "Age": 61,
    "Count": 0
  },
  {
    "Race": "Majority Black",
    "Age": 62,
    "Count": 0
  },
  {
    "Race": "Majority Black",
    "Age": 63,
    "Count": 0
  },
  {
    "Race": "Majority Black",
    "Age": 64,
    "Count": 0
  },
  {
    "Race": "Majority Black",
    "Age": 65,
    "Count": 0
  },
  {
    "Race": "Majority Black",
    "Age": 66,
    "Count": 0
  },
  {
    "Race": "Majority Black",
    "Age": 67,
    "Count": 5
  },
  {
    "Race": "Majority Black",
    "Age": 68,
    "Count": 5
  },
  {
    "Race": "Majority Black",
    "Age": 69,
    "Count": 9
  },
  {
    "Race": "Majority Black",
    "Age": 70,
    "Count": 6
  },
  {
    "Race": "Majority Black",
    "Age": 71,
    "Count": 11
  },
  {
    "Race": "Majority Black",
    "Age": 72,
    "Count": 12
  },
  {
    "Race": "Majority Black",
    "Age": 73,
    "Count": 13
  },
  {
    "Race": "Majority Black",
    "Age": 74,
    "Count": 7
  },
  {
    "Race": "Majority Black",
    "Age": 75,
    "Count": 3
  },
  {
    "Race": "Majority Black",
    "Age": 76,
    "Count": 6
  },
  {
    "Race": "Majority Black",
    "Age": 77,
    "Count": 1
  },
  {
    "Race": "Majority Black",
    "Age": 78,
    "Count": 0
  },
  {
    "Race": "Majority Black",
    "Age": 79,
    "Count": 0
  },
  {
    "Race": "Majority Black",
    "Age": 80,
    "Count": 0
  },
  {
    "Race": "Majority Black",
    "Age": 81,
    "Count": 0
  },
  {
    "Race": "Majority Black",
    "Age": 82,
    "Count": 0
  },
  {
    "Race": "Majority Black",
    "Age": 83,
    "Count": 0
  },
  {
    "Race": "Majority Black",
    "Age": 84,
    "Count": 0
  },
  {
    "Race": "Majority Black",
    "Age": 85,
    "Count": 0
  },
  {
    "Race": "Majority Black",
    "Age": 86,
    "Count": 0
  },
  {
    "Race": "Majority Black",
    "Age": 87,
    "Count": 0
  },
  {
    "Race": "Majority Black",
    "Age": 88,
    "Count": 0
  },
  {
    "Race": "Majority Black",
    "Age": 89,
    "Count": 0
  },
  {
    "Race": "Majority Black",
    "Age": 90,
    "Count": 0
  },
  {
    "Race": "Majority Black",
    "Age": 91,
    "Count": 0
  },
  {
    "Race": "Majority Black",
    "Age": 92,
    "Count": 0
  },
  {
    "Race": "Majority Black",
    "Age": 93,
    "Count": 0
  },
  {
    "Race": "Majority Black",
    "Age": 94,
    "Count": 0
  }
]
